import React, { useState, useEffect } from "react";
import "./pfuview.scss";
import Grid from "@material-ui/core/Grid";
import bulk_reschedule_calendar from "../../../../assets/bulk_reschedule_calendar.svg";
import { Calendar } from "react-calendar";
import moment from "moment";
import deleteicon from "../../../../assets/delete_icon_pre.svg";
import useDebounce from "../../common/debounce";

const PatientFollowUp = ({
  followUpDate,
  setFollowUpDate,
  appointmentData,
  setSelectedDays,
  frequencyList,
  selectedDays,
  updateFollowUpDate,
}) => {
  const [showCalendar, setShowCalendar] = useState(false);

  const debounceForFollowUpDate = useDebounce(followUpDate, 500);

  useEffect(() => {
    if (debounceForFollowUpDate?.call_api) {
      let formattedDate = followUpDate?.value
        ? moment(followUpDate?.value).format("YYYY-MM-DD")
        : "";
      updateFollowUpDate(appointmentData?.appointment_id, formattedDate);
    }
  }, [debounceForFollowUpDate]);

  const renderRadio = () => {
    return (
      <Grid className="patient-follow-up-radio-btn-container" container>
        {frequencyList?.map((ev, ind) => {
          return (
            <Grid
              className="patient-patient-follow-up-radio-btn"
              item
              md={2}
              key={ind}
            >
              <div
                id="followup"
                className="d-flex justify-content-start align-items-center"
              >
                <input
                  className="patient-followup-main-radio mr-3"
                  type="radio"
                  id={ev.title}
                  name={"followup"}
                  value={selectedDays}
                  onChange={() => {
                    setSelectedDays(ev.value);
                    setFollowUpDate({
                      call_api: true,
                      value: moment(new Date())
                        .add(ev.value, "days")
                        .format("DD MMM YYYY"),
                    });
                  }}
                  checked={ev.value === selectedDays}
                />
                <label
                  className="patient-followup-main-radiotitle m-0"
                  htmlFor={ev.title}
                >
                  {ev.title}
                </label>
              </div>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const handleSelectedDate = (date) => {
    let follow = moment(new Date(date)).format("DD MMM YYYY");
    setFollowUpDate({ call_api: true, value: follow });
    setSelectedDays("");
    setShowCalendar(false);
  };
  const onDeleteClick = () => {
    setFollowUpDate({ call_api: true, value: "" });
    setSelectedDays("");
  };
  const renderCalendar = () => {
    return (
      <>
        <div className="d-flex patient-follow-up-content-wrpaaer">
          <div className="d-flex flex-column justify-content-between patient-follow-date-wrapper">
            <div className="select-date-header">Next Follow-up Date</div>
            <div className="d-flex">
              <div
                className="pfu-calendar-input p-0"
                onClick={() => setShowCalendar(!showCalendar)}
              >
                <div className={"pfu-calendar-input-value p-2"}>
                  {followUpDate?.value?.trim() &&
                    moment(new Date(followUpDate?.value)).format("DD MMM YYYY")}
                </div>
                <div
                  className={"pfu-calendar-input-append pr-3 pl-3 pb-2 pt-1"}
                >
                  <img
                    src={bulk_reschedule_calendar}
                    alt=""
                    height="20px"
                    width="20px"
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-end ml-2 mb-2">
                <img
                  src={deleteicon}
                  height="20px"
                  width="20px"
                  style={{ cursor: "pointer" }}
                  onClick={onDeleteClick}
                />
              </div>
            </div>
          </div>
          {renderRadio()}
        </div>
        <div
          style={{ position: "relative" }}
          className={`${
            !followUpDate?.value
              ? "pfu-view-show-current"
              : "pfu-view-hide-current"
          }`}
        >
          {showCalendar && (
            <Calendar
              value={
                selectedDays
                  ? new Date(moment(new Date()).add(selectedDays, "days"))
                  : followUpDate?.value
                  ? new Date(moment(followUpDate?.value))
                  : ""
              }
              minDate={new Date()}
              onChange={handleSelectedDate}
              maxDate={moment(new Date()).add(12, "months")._d}
            />
          )}
        </div>
      </>
    );
  };

  return <div className="patient-followup-main">{renderCalendar()}</div>;
};
export default PatientFollowUp;
